<template>
  <VCard flat>
    <VAlert
      type="info"
      :value="true"
      class="ma-0"
    >
      {{ $nt('attention') }}
    </VAlert>
    <VForm
      v-model="isFormValid"
      @submit.prevent="editPersonalInfo"
    >
      <VCardText>
        <EmailInput
          v-model="email"
          :email-error="errorMessages.email"
        />
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          color="primary"
          type="submit"
          :loading="isLoading"
          :disabled="isLoading || !isFormValid"
        >
          {{ $nt('edit') }}
        </VBtn>
      </VCardActions>
    </VForm>
  </VCard>
</template>

<script>
import { mapGetters } from 'vuex'
import UserApi from '@/api/UserApi'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'

export default {
  name: 'EmailSettings',
  components: { EmailInput },
  data () {
    return {
      isLoading: false,
      isFormValid: false,
      errorMessages: {},
      email: ''
    }
  },
  computed: {
    ...mapGetters('user', ['getUser'])
  },
  methods: {
    async editPersonalInfo () {
      if (this.isFormValid) {
        try {
          this.isLoading = true
          const result = await UserApi.updateEmail({ email: this.email })
          this.$notification(result)
        } catch (e) {
          this.errorMessages = e.errors
        }
        this.isLoading = false
      }
    }
  },
  watch: {
    email () {
      this.errorMessages = {}
    }
  },
  created () {
    this.email = this.getUser.email
  }
}
</script>
